const map = {
	"./auto_on.png": 364,
	"./mains_on.png": 9425,
	"./manual_on.png": 2277,
	"./off_on.png": 4314,
	"./old/auto_on.png": 9302,
	"./old/mains_on.png": 643,
	"./old/manual_on.png": 8983,
	"./standby_on.png": 5490
};


function webpackContext(req) {
	const id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		const e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6852;